import React, { useState } from "react";
import ProviderCard from "./ProviderCard";
import ProviderDetailCard from "./ProviderDetailCard";
import VQALibraryCard from "./VQALibraryCard";

const CustomCards = ({
  type,
  services,
  city,
  country,
  rfi,
  assessment,
  documents,
  badgeColor,
  imageUrl,
  name,
  documentType,
  documentDetails,
  hardCodedServices,
  vqa,
  report,
  status,
  id,
  publishedDate,
  assessmentDate,
  onClick,
  docLocation,
  docLocationFull,
  requestedDate,
  documentName,
  entityId,
  docId,
  questionnaireId,
  sponsorRfiResponseId,
  details,
  isLegacyRfi,
  v1_doc_id,
  v1_doc_name,
  address1,
  hideRequestActions = false,
  additionalScope,
  libraryRefetch,
  archiveDocumentContext = "library",
}) => {
  const [show, setShow] = useState(false);

  return (
    <div onClick={() => setShow(true)}>
      {vqa ? (
        <VQALibraryCard
          type={type}
          services={services}
          imageUrl={imageUrl}
          name={name}
          documentType={documentType}
          report={report}
        />
      ) : documents ? (
        <ProviderCard
          type={type}
          services={services}
          city={city}
          country={country}
          rfi={rfi}
          assessment={assessment}
          badgeColor={badgeColor}
          imageUrl={imageUrl}
          name={name}
          id={id}
          address1={address1}
        />
      ) : (
        <ProviderDetailCard
          documentType={documentType}
          badgeColor={badgeColor}
          name={name}
          services={services}
          status={status}
          publishedDate={publishedDate}
          assessmentDate={assessmentDate}
          onClick={onClick}
          docLocation={docLocation}
          docLocationFull={docLocationFull}
          requestedDate={requestedDate}
          documentName={documentName}
          entityId={entityId}
          docId={docId}
          questionnaireId={questionnaireId}
          sponsorRfiResponseId={sponsorRfiResponseId}
          details={details}
          isLegacyRfi={isLegacyRfi}
          v1_doc_id={v1_doc_id}
          v1_doc_name={v1_doc_name}
          hideRequestActions={hideRequestActions}
          additionalScope={additionalScope}
          libraryRefetch={libraryRefetch}
          archiveDocumentContext={archiveDocumentContext}
        />
      )}
    </div>
  );
};

export default CustomCards;
